import * as React from "react";
import { FaHome } from "react-icons/fa";

import '../styles/MetamodelSelector.css';
import '../styles/ReportGenerator.css';
import helpIcon from '../../assets/icons/help-square.svg'

import Config from "../Config";
import Commons from "../utils/Commons";
import RequestHelper from "../utils/RequestHelper";
import ANPObjectCreator from "../utils/WordFileHandler";
import ReportGeneratorStep from "./ReportGeneratorStep";
import ModalMessage from "./modals/ModalMessage";
import StateGlobal from "../StateGlobal";
import { encode } from "base64-arraybuffer";
import { isOauth, isBasicAuth, checkToken, refreshToken } from "./oauth/OAuth";
import Loader from "./Loader.jsx";

export default class ReportGenerator extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            readyToGenerate: true,
            displayError: false,
            errorMessage: null,
            errorMessageDefault: "Error",
            reportPreparing: false,
            reportGenerateBtn: false,
            reportPreparingMsg: Config.strings.reportGenerator.reportPreparingMessage,
        };

        this.failureCallback = this.props.failureCallback;

        this.aTemplatesSelectionRef = React.createRef();
        this.aEntitiesSelectionRef = React.createRef();
        this.aGenerationRef = React.createRef();
        this.aModalMessage = React.createRef();

        Config.getConfig();
        StateGlobal.getState();
    }

    downloadFile = (sFilename, sText) =>
    {
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(sText));
        element.setAttribute('download', sFilename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    getObjTemplateBase64 = async (aTemplateData) =>
    {

        if (!Config.aAnpRepo.id)
        {
            throw new Error("Repository ID is missing. Please select proper repository in Report Creator configuration.!");
        }

        let sTemplateDoc = null;

        // ======================================================================= oauth
        if(isOauth()){
            const sCredentials = JSON.parse(localStorage.getItem('SSO-Credentials'));
            
            const response = await fetch(
                Commons.createGatewayRequestUrl(
                    {
                        url: Config.anpRequestUrl.getObjectDoc
                            .replace(/%repo_id%/g, Config.aAnpRepo.id)
                            .replace(/%obj_id%/g, aTemplateData.id)
                            .replace(/%attr_name%/g, (Commons.isAdoit() ? "A_REFERENCED_REPRESENTATION" : "REFERENCED_DOCUMENT")),
                        dataType: "blob"
                    })
                ,{
                headers: {
                    'Authorization': `Bearer ${sCredentials.access_token}`
                }
            });
            const arrayBuffer = await response.arrayBuffer();
            sTemplateDoc = encode(new Uint8Array(arrayBuffer).buffer);
        }
        // ======================================================================= oauth

        if(isBasicAuth()){
            await RequestHelper.sendRequestSimple(
                {
                    request: Commons.createGatewayRequestUrl(
                        {
                            url: Config.anpRequestUrl.getObjectDoc
                                .replace(/%repo_id%/g, Config.aAnpRepo.id)
                                .replace(/%obj_id%/g, aTemplateData.id)
                                .replace(/%attr_name%/g, (Commons.isAdoit() ? "A_REFERENCED_REPRESENTATION" : "REFERENCED_DOCUMENT")),
                            dataType: "blob"
                        }),
                    dataType: "text",
                })
                .then((aResponse) =>
                {
                    if (aResponse && aResponse.isErr)
                    {
                        console.error(aResponse.message);
                        throw new Error(aResponse.message)
                    }
                    sTemplateDoc = aResponse;
                });
        }
        if (!sTemplateDoc)
        {
            throw new Error("Failed fetching template document!")
        }

        return sTemplateDoc;
    }

    getEntitiesFromQuery = async (aQueries) =>
    {
        let aQueryEntities = {
            models: [],
            objects: []
        }

        if (!aQueries || 0 >= aQueries.length)
        {
            return aQueryEntities;
        }

        try
        {
            if (!Config.aAnpRepo.id)
            {
                throw new Error("Repository ID is missing. Please select proper repository in Report Creator configuration.!");
            }

            let aQueriesItems = [];
            for (let i = 0; i < aQueries.length; i++)
            {
                if (!aQueries[i].hasOwnProperty("id") || !aQueries[i].id)
                {
                    continue;
                }

                await RequestHelper.sendRequestSimple(
                    {
                        request: Commons.createGatewayRequestUrl(
                            {
                                url: Config.anpRequestUrl.getQuery
                                    .replace(/%repo_id%/g, Config.aAnpRepo.id)
                                    .replace(/%query_id%/g, aQueries[i].id),
                                dataType: "json"
                            }),
                        dataType: "json",
                    }).then((aResponse) =>
                    {
                        if (aResponse && aResponse.isErr)
                        {
                            console.error(aResponse.message);
                            throw new Error(aResponse.message)
                        }
                        if (aResponse.hasOwnProperty("items") && 0 < aResponse.items.length)
                        {
                            aResponse.items.forEach(aRespItem =>
                            {
                                if (!aQueriesItems.find(aQueriedItem =>
                                {
                                    return aQueriedItem.id === aRespItem.id
                                }))
                                {
                                    aQueriesItems.push(aRespItem);
                                }
                            });
                        }
                    });
            }
            if (aQueriesItems && 0 < aQueriesItems.length)
            {
                const aQueriesModels = aQueriesItems.filter(aItem =>
                {
                    if ("DIAGRAM" === aItem.artefactType)
                    {
                        return true;
                    }
                    return false;
                }).map(aItem =>
                {
                    return {
                        id: Commons.removeCurlyBracketsFromId(aItem.id),
                        name: aItem.name
                    };
                });
                const aQueriesObjects = aQueriesItems.filter(aItem =>
                {
                    if ("REPOSITORY_OBJECT" === aItem.artefactType) // MODELLING INSTANCES NOT SUPPORTED
                    {
                        return true;
                    }
                    return false;
                }).map(aItem =>
                {
                    return {
                        id: Commons.removeCurlyBracketsFromId(aItem.id),
                        name: aItem.name
                    };
                });
                aQueryEntities.models = aQueriesModels ? aQueriesModels : [];
                aQueryEntities.objects = aQueriesObjects ? aQueriesObjects : [];
            }
            return aQueryEntities;
        } catch (aEx)
        {
            console.error(aEx);
            return null;
        }
    }

    resetError = () =>
    {
        this.setState({
            displayError: false
        });
    }

    generateReport = async () =>
    {
        

        if(isOauth()){
            await refreshToken().then((response) => {
                if (!response.ok) {
                    console.log(response.message)
                    return;
                }
            })
        }

        this.setState({
            reportPreparing: true,
            reportGenerateBtn: true,
            reportPreparingMsg: Config.strings.reportGenerator.reportPreparingMessage
        });
        this.resetError();
        try
        {
            if (Config.nMaxActiveReportReq <= StateGlobal.getActiveReportReq())
            {
                this.setState({
                    displayError: true,
                    reportPreparing: false,
                    reportGenerateBtn: false,
                    errorMessage: Config.strings.errorMessages.reportGenerator.userQueueFull.replace(/%s/g, StateGlobal.getActiveReportReq())
                });
                return;
            }

            if (!this.aTemplatesSelectionRef.current)
            {
                this.setState({
                    displayError: true,
                    reportPreparing: false,
                    reportGenerateBtn: false,
                    errorMessage: Config.strings.errorMessages.reportGenerator.cannotSelect
                });
                return;
            }
            if (!this.aEntitiesSelectionRef.current)
            {
                this.setState({
                    displayError: true,
                    reportPreparing: false,
                    reportGenerateBtn: false,
                    errorMessage: Config.strings.errorMessages.reportGenerator.cannotSelect
                });
                return;
            }
            const aTemplateData = this.aTemplatesSelectionRef.current.getSelected();
            const aEntitiesDataPre = this.aEntitiesSelectionRef.current.getSelected();

            let aEntitiesData = {
                models: aEntitiesDataPre.models,
                objects: aEntitiesDataPre.objects
            };

            if (aEntitiesDataPre.hasOwnProperty("queries") && 0 < aEntitiesDataPre.queries.length)
            {
                this.setState({
                    reportPreparing: true,
                    reportGenerateBtn: true,
                    reportPreparingMsg: Config.strings.reportGenerator.reportPreparingQuery
                });

                const aQueryEntities = await this.getEntitiesFromQuery(aEntitiesDataPre.queries);

                if (aQueryEntities.hasOwnProperty("models") && 0 < aQueryEntities.models.length)
                {
                    aQueryEntities.models.forEach(aEntity =>
                    {
                        if (!aEntitiesData.models.find(aEntityData =>
                        {
                            return aEntityData.id === aEntity.id;
                        }))
                        {
                            aEntitiesData.models.push(aEntity);
                        }
                    });
                }
                if (aQueryEntities.hasOwnProperty("objects") && 0 < aQueryEntities.objects.length)
                {
                    aQueryEntities.objects.forEach(aEntity =>
                    {
                        if (!aEntitiesData.objects.find(aEntityData =>
                        {
                            return aEntityData.id === aEntity.id;
                        }))
                        {
                            aEntitiesData.objects.push(aEntity);
                        }
                    });
                }

                this.setState({
                    reportPreparing: true,
                    reportGenerateBtn: true,
                    reportPreparingMsg: Config.strings.reportGenerator.reportPreparingMessage
                });
            }

            if (!Config.aAnpRepo.id)
            {
                throw new Error("Repository ID is missing. Please select proper repository in Report Creator configuration.!");
            }
            if (aTemplateData.length <= 0)
            {
                this.setState({
                    displayError: true,
                    reportPreparing: false,
                    reportGenerateBtn: false,
                    errorMessage: Config.strings.errorMessages.reportGenerator.noTemplate
                });
                return;
            }
            if (!(
                (aEntitiesData.hasOwnProperty("models") && 0 < aEntitiesData.models.length) ||
                (aEntitiesData.hasOwnProperty("objects") && 0 < aEntitiesData.objects.length)
            ))
            {
                this.setState({
                    displayError: true,
                    reportPreparing: false,
                    reportGenerateBtn: false,
                    errorMessage: Config.strings.errorMessages.reportGenerator.noEntity
                });
                return
            }

            this.setState({
                reportPreparing: true,
                reportGenerateBtn: true,
                reportPreparingMsg: Config.strings.reportGenerator.reportPreparingGettingTemplate
            });
            const sTemplateDocBase64 = await this.getObjTemplateBase64(aTemplateData[0]);

            this.setState({
                reportPreparing: true,
                reportGenerateBtn: true,
                reportPreparingMsg: Config.strings.reportGenerator.reportPreparingMessage
            });

            let aReportEntities = [];
            for (let sKey in aEntitiesData)
            {
                let sType = "model";
                switch (sKey)
                {
                    case "models":
                        sType = "model";
                        break;
                    case "objects":
                        sType = "object";
                        break;
                }
                aEntitiesData[sKey].forEach(aEntity =>
                {
                    aReportEntities.push({
                        type: sType,
                        id: aEntity.id
                    });
                });
            }

            const aReportParams = {
                template: sTemplateDocBase64,
                repo: Config.aAnpRepo.id,
                adoOrigin: Config.baseURL,
                data: aReportEntities
            };

            if (this.aModalMessage.current)
            {
                this.aModalMessage.current.setMessage(Config.strings.messages.reportGenerator.reportSentToGen);
                this.aModalMessage.current.openModal();
            }

            this.setState({
                reportPreparing: false,
                reportGenerateBtn: true,

            });

            try
            {
                StateGlobal.incActiveReportReq();
                await RequestHelper.sendRequestSimple(
                    {
                        request: Commons.createGatewayRequestUrl(
                            {
                                url: Config.requestEngine,
                                dataType: "text",
                                isCustomUrl: true
                            }),
                        dataType: "text",
                        headers:
                        {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(aReportParams),
                        method: "POST"
                    }).then((aResponse) =>
                    {
                        if (aResponse && aResponse.isErr)
                        {
                            if (this.aModalMessage.current)
                            {
                                this.aModalMessage.current.closeModal();
                            }
                            if (aResponse.message.startsWith("429"))
                            {
                                this.failureCallback(Config.strings.errorMessages.reportGenerator.engineOverloaded);
                            } else
                            {
                                this.failureCallback(Config.strings.errorMessages.reportGenerator.requestFailed);
                                console.error(new Error(aResponse.message));
                            }
                        }
                        if (typeof aResponse === "string")
                        {
                            this.setState({
                                reportPreparing: false,
                                reportGenerateBtn: false,
                            });                
                            ANPObjectCreator.downloadFileFromEncoded(aResponse)
                        }
                    });
            } catch (aEx)
            {
                throw aEx;
            } finally
            {
                StateGlobal.decActiveReportReq();
            }
        } catch (aEx)
        {
            this.setState({
                reportPreparing: false,
                reportGenerateBtn: false,

            });
            this.failureCallback(Config.strings.errorMessages.reportGenerator.requestPreparationFailed);
            console.error(aEx);
        }
    }

    render()
    {
        const { moveBackFn } = this.props;
        return (
            <div>
                <div className="MetamodelSelector__topContainer">
                    <div className="MetamodelSelector__topBtnContainerBetween MetamodelSelector__topBtnContainerBetween--right-margin-fix">
                        <button
                            className="wrcWidget__buttonIcon wrcWidget__buttonIcon--dark cursor-pointer"
                            onClick={() =>
                            {
                                if (this.state.reportPreparing)
                                {
                                    return;
                                }
                                this.resetError();
                                moveBackFn(null);
                            }}
                        >
                            <FaHome style={{ fontSize: 16 }} />
                        </button>
                        <button
                                className="wrcWidget__buttonIcon wrcWidget__buttonIcon--dark cursor-pointer"
                                onClick={()=>{
                                    window.location.href = Config.rcwAppDocumentation;
                                }}
                            >
                                <img src={helpIcon} height={18}/>
                        </button>
                    </div>
                </div>
                <div className="ReportGenerator__container">
                    <ReportGeneratorStep
                        ref={this.aTemplatesSelectionRef}
                        label={Config.strings.reportGenerator.step1.label}
                        btnLabel={Config.strings.reportGenerator.step1.btnLabel}
                        listLabel={Config.strings.reportGenerator.step1.listLabel}
                        listSeparator={", "}
                        content="templates"
                        confirmCallback={this.resetError}
                        disableBtn={this.state.reportPreparing}
                    />
                    <ReportGeneratorStep
                        ref={this.aEntitiesSelectionRef}
                        label={Config.strings.reportGenerator.step2.label}
                        btnLabel={Config.strings.reportGenerator.step2.btnLabel}
                        listLabel={Config.strings.reportGenerator.step2.listLabel}
                        listSeparator={"\n"}
                        content="entities"
                        confirmCallback={this.resetError}
                        disableBtn={this.state.reportPreparing}
                        btnAdditional={true}
                        btnAdditionalLabel={Config.strings.reportGenerator.step2.additionalBtnLabel}
                    />
                    <ReportGeneratorStep
                        ref={this.aGenerationRef}
                        label={Config.strings.reportGenerator.step3.label}
                        btnLabel={Config.strings.reportGenerator.step3.btnLabel}
                        noSelection={true}
                        confirmCallback={this.generateReport}
                        disableBtn={this.state.reportPreparing}
                    />
                    {
                        this.state.displayError &&
                        <h4 className="App__errorMessage" >
                            {this.state.errorMessage ? this.state.errorMessage : this.state.errorMessageDefault}
                        </h4>
                    }
                    {
                        this.state.reportPreparing ?
                            <h3 className="App__infoMessage" >
                                <Loader label={this.state.reportPreparingMsg}/>
                            </h3> :
                            null
                    }
                </div>
                <ModalMessage ref={this.aModalMessage} />
            </div>
        );
    }
}